import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import styles from './../style/Showroom.module.scss'

import { Container, Image, Row, Col } from 'react-bootstrap'

import SimleForm from './SimleForm'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox'

class Showroom extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.state = {
      activeIndex: 0,
      lightboxController: {
        toggler: false,
        slide: 1
      }
    }
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext()
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev()
    }
  }

  handleSlideChange = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.setState({
        activeIndex: this.swiperRef.current.swiper.realIndex
      })
    }
  }

  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  formatSlideNumber = (index) => {
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {
    const { assets_path, dark_bg, dark_bg_mob, data, margin } = this.props
    const { lightboxController } = this.state

    return (
      <section className={`${styles.section} ${styles[margin]}`}>
        {dark_bg != '' &&
          <>
            <Image className={styles.section_bg} src={dark_bg} width={1920} height={360} alt={`Фон`} />
            <Image className={styles.section_bg_mob} src={dark_bg_mob} width={375} height={482} alt={`Фон моб.`} />
          </>
        }
        <div className={styles.section_content}>
          <Container>
            <h2 className={styles.title} dangerouslySetInnerHTML={{__html: data?.title}} />
            <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text}} />
          </Container>
          <div className={styles.sep}></div>
          <Container>
            {/* Lightbox компонент */}
            <ClientOnlyFsLightbox
              toggler={lightboxController.toggler}
              sources={data?.list?.map(item => item.full || item.image) || []}
              slide={lightboxController.slide}
            />
            
            <Row>
              <Col md={6}>
                <SimleForm
                  btn={`Записаться в шоурум`}
                  assets_path={assets_path}
                  width={195}
                  svg={(
                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.0918 7.90998L7.90998 1.0918M7.90998 1.0918H2.45543M7.90998 1.0918V6.54634" stroke="#00C775" strokeLinecap="round"/>
                    </svg>
                  )}
                  name={true}
                />
              </Col>
              
              {/* Заменяем статическое изображение на слайдер */}
              {data?.list && data.list.length > 0 &&
                <Col md={6}>
                  <div className={styles.slider_container}>
                    <Swiper
                      ref={this.swiperRef}
                      modules={[Navigation]}
                      spaceBetween={10}
                      slidesPerView={1}
                      loop={true}
                      onSlideChange={this.handleSlideChange}
                      onSwiper={(swiper) => {
                        this.setState({ activeIndex: swiper.realIndex })
                      }}
                    >
                      {data.list.map((item, index) => (
                        <SwiperSlide key={index}>
                          <div className={styles.slide}>
                            <div onClick={() => this.openLightbox(index)} style={{cursor: 'pointer'}}>
                              <Image 
                                className={styles.slide_image} 
                                src={item.image} 
                                width={338} 
                                height={360} 
                                alt={item.name} 
                                loading="lazy"
                              />
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    
                    {/* Навигационные кнопки */}
                    <div className={styles.slider_nav}>
                      <div className={styles.slider_nav_btn} onClick={this.prevSlide}>
                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.3212 4.50087H1.67882M1.67882 4.50087L5.53576 0.643924M1.67882 4.50087L5.53576 8.35782" stroke="white" strokeLinecap="round" />
                        </svg>
                      </div>
                      <div className={styles.slider_nav_btn} onClick={this.nextSlide}>
                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="white" strokeLinecap="round" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </Col>
              }
            </Row>
          </Container>
        </div>
      </section>
    )
  }
}

Showroom.propTypes = {
  data: PropTypes.object,
  dark_bg: PropTypes.string,
  dark_bg_mob: PropTypes.string,
  assets_path: PropTypes.string,
  margin: PropTypes.string
}

Showroom.defaultProps = {
  data: {},
  dark_bg: '',
  dark_bg_mob: '',
  assets_path: 'assets',
  margin: `none`
}

export default Showroom